module.exports = __webpack_public_path__ + "static/media/wheel.0ed60aeb.png";